// extracted by mini-css-extract-plugin
module.exports = {"container":"ShadowCard_container__3KQkF","card":"ShadowCard_card__3Qo2M"};